import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { Auth0Provider, useAuth0 } from '@auth0/auth0-react';
import { AuthProvider } from './contexts/AuthContext';
import { auth0Config } from './auth/auth0-config';
import { Navbar } from './components/layout/Navbar';
import { Footer } from './components/layout/Footer';
import { Home } from './pages/Home';
import { BrowseProjects } from './pages/BrowseProjects';
import { SellProject } from './pages/SellProject';
import Login from './pages/Login';
import { ProjectDetails } from './pages/ProjectDetails';
import { UserSettings } from './pages/UserSettings';
import { Toaster } from 'react-hot-toast';
import { init } from '@chaseleto/sessions-sdk'



// Protected Route wrapper component
const ProtectedRoute = ({ children }: { children: React.ReactNode }) => {
  const { isAuthenticated, isLoading } = useAuth0();

  if (isLoading) {
    return <div>Loading...</div>;
  }

  if (!isAuthenticated) {
    return <Navigate to="/" />;
  }

  return <>{children}</>;
};

function App() {
  return (
    <Auth0Provider
      domain={auth0Config.domain}
      clientId={auth0Config.clientId}
      authorizationParams={{
        ...auth0Config.authorizationParams,
        scope: 'openid profile email'
      }}
      useRefreshTokens={true}
      cacheLocation="localstorage"
    >
      <AuthProvider>
        <Router>
          <div className="min-h-screen bg-gray-50 flex flex-col">
            <Navbar />
            <main className="flex-grow">
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/projects" element={<BrowseProjects />} />
                <Route path="/projects/:id" element={<ProjectDetails />} />
                <Route
                  path="/sell-your-project"
                  element={
                    <ProtectedRoute>
                      <SellProject />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/settings"
                  element={
                    <ProtectedRoute>
                      <UserSettings />
                    </ProtectedRoute>
                  }
                />
                <Route path="/dashboard" element={<div>User Dashboard</div>} />
                <Route path="/admin" element={<div>Admin Dashboard</div>} />
                <Route path="/login" element={<Login />} />
              </Routes>
            </main>
            <Footer />
            <Toaster position="top-right" />
          </div>
        </Router>
      </AuthProvider>
    </Auth0Provider>
  );
}

export default App; 